import React from 'react';
import { Alert } from "react-bootstrap";

const SyncMessage = ({ res, reqErr }) => {
    let message, type;

    if(reqErr) {
        message = `Request Error - ${reqErr.toString()}`;
        type = 'danger';
    }
    else if(res && res.status === 'success') {
        message = 'Success';
        type = 'success';
    }
    else if(res && res.status === 'error') {
        message = res.errors.map(err => <div>{err.server} - {err.error}</div>);
        type = 'danger';
    }

    if(message) {
        return (
            <Alert bsStyle={type}>
                {message}
            </Alert>
        );
    }

    return null;
}

export default SyncMessage;


// WEBPACK FOOTER //
// ./src/components/SyncMessage/index.js